import { render, staticRenderFns } from "./vueDialog.vue?vue&type=template&id=501e7e43&scoped=true&"
import script from "./vueDialog.vue?vue&type=script&lang=js&"
export * from "./vueDialog.vue?vue&type=script&lang=js&"
import style0 from "./vueDialog.vue?vue&type=style&index=0&id=501e7e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e7e43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
